import PropTypes from 'prop-types';
import React from 'react';

import indiaAuthSignatureSrc from './indiaAuthSignatureSrc';

function IndiaAuthSignature({ locale }) {
  if (locale !== 'en-IN') {
    return null;
  }

  return (
    <>
      <article className="justify-between pt2-sm" style={{ justifyContent: 'center' }}>
        <p>FOR NIKE INDIA PVT.LTD.</p>
      </article>
      <article className="justify-between p4-sm" style={{ justifyContent: 'center' }}>
        <img alt="ind_auth_signature" height="36" src={indiaAuthSignatureSrc} width="110" />
      </article>
      <article className="justify-between pb4-sm" style={{ justifyContent: 'center' }}>
        <p>Authorized Signatory</p>
      </article>
    </>
  );
}

IndiaAuthSignature.propTypes = {
  locale: PropTypes.string.isRequired
};

export default IndiaAuthSignature;
